import { ApisauceInstance } from 'apisauce';

// Activates SSO once FleetOps has approved the groups. Starts the first sync.
const postActivate = async (api: ApisauceInstance): Promise<boolean> => {
  const response = await api.post('/v1/sso/microsoft/activate', {});
  return response.ok;
};

export default postActivate;
